<div class="phase-list">
  <div class="spacer"></div>
  @for (phase of phases; track phase) {
    <div
      (click)="selectPhase(phase._id)"
      [ngClass]="{ selected: phase._id == currentPhaseId }"
      class="phase-title"
      >
      {{ phase.title }}
    </div>
  }
</div>
